// libs
import classNames from 'classnames'
import * as React from 'react'

// styles
import './checkbox.scss'

// components
import { SvgIcon } from 'src/components/icons/svg-icon'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import { IKeyValue } from 'src/interfaces/'

interface IProps {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  label?: React.ReactNode;
  onClick?: () => void;
  required?: boolean;
  valid?: boolean;
}

const clsBlock = CLASS_PREFIX + 'checkbox'

export const Checkbox = ({ checked, label, className, disabled, onClick, required, valid = true }: IProps) => {
  const cls: IKeyValue = {}

  cls[clsBlock] = true
  cls[`${clsBlock}--checked`] = checked
  cls[`${clsBlock}--disabled`] = disabled
  cls[`${clsBlock}--invalid`] = !valid

  // A <label> root associates the whole component with the native input,
  // so clicks toggle it and the label content is its accessible name.
  // Links inside the label keep working: activating interactive content
  // does not trigger the label's control (HTML label activation rules).
  return (
    <label className={classNames(cls)}>
      <span className={classNames(`${clsBlock}__wrapper`, className)}>
        <input
          type="checkbox"
          className={`${clsBlock}__input`}
          checked={checked ?? false}
          disabled={disabled}
          aria-required={required || undefined}
          onChange={() => onClick?.()}
        />
        <span className={`${clsBlock}__box-outline`} aria-hidden="true">
          {checked && <SvgIcon name="General/check" size={12} gradient={!disabled} color={disabled ? 'var(--icon-disabled)' : undefined} className={`${clsBlock}__check-icon`} />}
        </span>
        { label &&
          <span className={`${clsBlock}__label`}>{label}</span>
        }
      </span>
    </label>
  )
}
